// extracted by mini-css-extract-plugin
module.exports = {"animated":"skeleton_animated__aMh0D","fading":"skeleton_fading__FHBM0"};